export enum ApiRoutesCompanyAdminAuth {
  SignIn = "/delivery-company/auth/sign-in",
  RefreshJwt = "/delivery-company/auth/jwt/refresh",
  Me = "/delivery-company/me"
}
